import { useEffect, useRef } from 'react';

export function useDatePickerScrollClose(
  isOpen: boolean,
  onClose: () => void
): React.RefObject<HTMLDivElement | null> {
  const anchorRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen || !anchorRef.current) {
      return;
    }
    const anchor = anchorRef.current;

    const handleScroll = () => {
      const rect = anchor.getBoundingClientRect();
      let scrollParentTop = 0;
      let parent = anchor.parentElement;
      while (parent && parent !== document.body) {
        const { overflow, overflowY } = window.getComputedStyle(parent);
        if (/auto|scroll/.test(overflow + overflowY)) {
          scrollParentTop = parent.getBoundingClientRect().top;
          break;
        }
        parent = parent.parentElement;
      }
      if (rect.bottom < scrollParentTop || rect.top > window.innerHeight) {
        onClose();
      }
    };

    window.addEventListener('scroll', handleScroll, true);
    return () => window.removeEventListener('scroll', handleScroll, true);
  }, [isOpen, onClose]);

  return anchorRef;
}
